import { SingleCard } from '@liveauctioneers/hammer-ui-core/card/singleCard';
import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';

import { ARTICLE_LINK_CARD_WIDTH_CLASS, ArticleLinkCard } from '@/components/ArticleLinkCard/ArticleLinkCard';
import { useAppSelector } from '@/redux/hooks';
import { getArticleLinks } from '@/redux/modules/articleLinks/articleLinks.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const ArticleLinksSection = ({ className }: { className?: string }) => {
    const links = useAppSelector(getArticleLinks);
    const formatMessage = useAppFormatMessage();

    if (links.length === 0) {
        return null;
    }

    const cards = links.map((link) => ({
        card: (
            <SingleCard
                card={ArticleLinkCard}
                className={ARTICLE_LINK_CARD_WIDTH_CLASS}
                data={link}
            />
        ),
        key: `related-article-${link.id}`,
    }));

    return (
        <div className={className}>
            <Carousel
                useOverlayControls
                cards={cards}
                title={formatMessage(['SEO', 'articleLinks', 'title'])}
            />
        </div>
    );
};
